import React from "react";
import DesktopNavbar from "./DesktopNavbar/DesktopNavbar.component";
import MobileNavbar from "./MobileNavbar/MobileNavbar.component";

function Navbar(props) {
  return (
    <div>
      <div className="d-lg-block d-none">
        <DesktopNavbar
          handleShowCart={props.handleShowCartModal}
          handleLoginModal={props.handleLoginModal}
          loginModal={props.loginModal}
          RegisterModal={props.RegisterModal}
          handleRegisterModal={props.handleRegisterModal}
        />
      </div>
      <div className="d-block d-lg-none">
        <MobileNavbar
          handleShowCart={props.handleShowCartModal}
          handleLoginModal={props.handleLoginModal}
          loginModal={props.loginModal}
          RegisterModal={props.RegisterModal}
          handleRegisterModal={props.handleRegisterModal}
        />
      </div>
    </div>
  );
}

export default Navbar;
